import styled from 'styled-components';

export const CompletionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
`;

export const CheckBubble = styled.div`
  width: 80px;
  height: 80px;
  background-color: #8cc4ff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #8cc4ff;
  }
`;

export const CompletionText = styled.p`
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

export const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  background-color: #171d25;
  padding: 2px;
`;

export const Tab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 8px;
  text-align: center;
  background-color: ${props => (props.active ? '#29313E' : '#171D25')};
  color: ${props => (props.active ? '#ffffff' : '#8B9299')};
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
`;

export const Badge = styled.span`
  color: #c4f538;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
`;

export const QuestsList = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuestItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: #1a222c;
  border-radius: 12px;
  cursor: pointer;
`;

export const QuestInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  background-color: #2c3037;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QuestName = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
`;

export const RewardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RewardAmount = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Ellipse = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 61px;
  height: 72px;
  background: #78bae5;
  filter: blur(57.50212860107422px);
`;

export const NoAvailableQuestText = styled.p`
  font-size: 14px;
  color: var(--color-neutral-5);
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  margin-top: 60px;
`;

export const CompletedDate = styled.p`
  font-family: Public-Sans, sans-serif;
  font-size: 12px;
  color: #6a7484;
  margin-left: 8px;
`;
